import { isSSR } from 'app/packages/components';

function getStrapiServerUrl() {
  const protocol = isSSR
    ? process.env.BACKEND_SERVER_PROTOCOL
    : window.__env.BACKEND_SERVER_PROTOCOL;

  const host = isSSR
    ? process.env.STRAPI_SERVER_HOST
    : window.__env.STRAPI_SERVER_HOST;

  return `${protocol}://${host}`;
}

export default getStrapiServerUrl;
